import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";

const formatCurrency = (value: number | null | undefined) => {
  if (value === null || value === undefined) return "";
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};
type Props = {
  onActionEditar: (Id: number | null, openState: boolean, openAnalise: boolean) => void,
  onActionDeletar: (Id: number | null, openState: boolean) => void,
};

export const GenerateServicoColumns = ({
  onActionEditar,
  onActionDeletar,
}: Props): GridColDef[] => {

  return [
    {
      field: "NomeProdutoServico",
      filterable: false,
      headerName: "Serviço",
      minWidth: 300,
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Unidade",
      filterable: false,
      headerName: "Unidade",
      width: 100, 
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Quantidade",
      filterable: false,
      headerName: "Qtde",
      width: 100,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "ValorUnitario",
      filterable: false,
      headerName: "Valor Unitário (R$)",
      width: 140, 
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{formatCurrency(params.value)}</span>
          </div>
        );
      },
    },
    { 
      field: "ValorTotal",
      filterable: false,
      headerName: "Total Líquido (R$)",
      width: 140, 
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{formatCurrency(params.value)}</span>
          </div>
        );
      },
    },
    {
      field: 'IdContratoServico',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEditar(params.value, true, false)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDeletar(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}